export const getScreenWidth = () => document.documentElement.clientWidth
